import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import OperationPage from "@/pages/OperationPage";
import PrivacyPage from "@/pages/PrivacyPage";
import { RedirectHome } from "@/components/RedirectHome";
import AdminLeads from "@/pages/AdminLeads";
import { CookieBanner } from "@/components/CookieBanner";
import { RouteTracker } from "@/components/RouteTracker";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/operazioni/:id" element={<OperationPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/lead-trilocale" element={<AdminLeads />} />
            {/* Landing trilocale dismessa (ordine del Presidente): redirect permanente alla home. I file restano nel codice. */}
            <Route path="/trilocale-paterno-12" element={<RedirectHome />} />
          </Routes>
          <CookieBanner />
          <RouteTracker />
        </BrowserRouter>
      </LangProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121216",
            border: "1px solid rgba(212,175,55,0.25)",
            color: "#F7F5F0",
          },
        }}
      />
    </div>
  );
}

export default App;
